import { EventTypes, HISTORY_ACTION_MODE } from '@candulabs/craft';
import React from 'react';

import { CRAFT_ROOT_ID } from 'craft/constants';
import { ReorderButton } from 'craft/containers/FloatingMenu/commons/ReorderButton';
import { useEditor } from 'craft/hooks';

export const ReorderTooltipButton = ({
  nodeId,
  index,
  direction,
  disabled,
  tooltipPlacement,
}: {
  nodeId: string;
  index: number;
  direction: 'left' | 'right';
  disabled: boolean;
  tooltipPlacement: 'top' | 'bottom';
}) => {
  const { actions } = useEditor();

  const onMove = () => {
    const newIndex = direction === 'left' ? index - 1 : index + 2;

    actions.move(nodeId, CRAFT_ROOT_ID, newIndex);
    actions.setNodeEvent(EventTypes.selected, nodeId, HISTORY_ACTION_MODE.MERGE);
  };

  return (
    <ReorderButton
      tooltipPlacement={tooltipPlacement}
      direction={direction}
      disabled={disabled}
      onClick={onMove}
    />
  );
};
